module.exports = __webpack_public_path__ + "img/dangjian.31d8e2dc.jpg";